// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fade-btn-enter-active[data-v-749b3a75] {
  transition: all 0.6s;
}
.fade-btn-enter[data-v-749b3a75] {
  opacity: 0;
}
.channel-comments[data-v-749b3a75] {
  max-height: 90%;
  width: 100%;
  min-width: 300px;
  margin: -25px -8px 15px -20px;
}
.channel-comments .header[data-v-749b3a75] {
  padding-bottom: 0px;
  padding-top: 10px;
}
.channel-comments .body[data-v-749b3a75] {
  padding: 0px;
  max-height: calc(var(--vh) * 85);
  flex-direction: column;
}
.channel-comments .body .send-comment[data-v-749b3a75] {
  display: flex;
  margin-top: 15px;
  border-radius: 5px;
  width: 100%;
}
.channel-comments .body .send-comment .send-comment-icon[data-v-749b3a75] {
  padding: 10px 5px 10px 15px;
}
.channel-comments .body .send-comment .send-comment-block[data-v-749b3a75] {
  padding: 10px;
  width: 100%;
  position: relative;
}
.channel-comments .body .send-comment .send-comment-block .textarea[data-v-749b3a75] {
  max-height: 300px;
  overflow: auto;
  width: 100%;
  outline: none;
  word-break: break-word;
  color: var(--main-body-color);
  border: 1px solid var(--list-item-bordercolor);
  border-radius: 20px;
  padding: 8px 16px;
  transition: border-color 0.15s linear, background-color 0.15s linear, color 0.15s linear;
  position: relative;
  z-index: 10;
  min-height: 40px;
}
.channel-comments .body .send-comment .send-comment-block .textarea[data-v-749b3a75]:hover {
  border-color: var(--list-item-bordercolor);
}
.channel-comments .body .send-comment .send-comment-block .textarea[data-v-749b3a75]:focus {
  border-color: var(--list-item-bordercolor);
}
.channel-comments .body .send-comment .send-comment-block .placeholder-textarea[data-v-749b3a75] {
  position: absolute;
  top: 19px;
  left: 27px;
  color: var(--custom-textarea-color);
  z-index: 9;
}
.channel-comments .body .send-comment .send-comment-block .send-comment-btn[data-v-749b3a75] {
  color: #8a92a4;
  background-color: var(--comment-btn-bgcolor);
  height: 40px;
  border-radius: 20px;
  text-align: center;
  display: inline-block;
  padding: 9px 30px;
  margin-top: 12px;
  cursor: pointer;
}
.channel-comments .body .send-comment .send-comment-block .send-comment-btn[data-v-749b3a75]:active {
  background-color: var(--comment-btn-bgcolor-hover);
}
.channel-comments .body .send-comment .send-comment-block .send-comment-btn[data-v-749b3a75]:hover {
  border-color: var(--list-item-bordercolor);
}
.channel-comments .body .send-comment .send-comment-block .active-btn[data-v-749b3a75] {
  background-color: var(--modal-elem-color);
  color: #ffffff;
}
.channel-comments .body .comments[data-v-749b3a75] {
  overflow: auto;
  width: 100%;
}
.channel-comments .body .comments .show-all[data-v-749b3a75] {
  opacity: 1;
  transition: all 0.7s;
}
.channel-comments .body .comments .hide-all[data-v-749b3a75] {
  opacity: 0;
}
.channel-comments .body .comments .show-first[data-v-749b3a75]:first-child {
  opacity: 1 !important;
  transition: all 0.7s;
}
.channel-comments .body .comments .hide-first[data-v-749b3a75]:first-child {
  opacity: 0 !important;
  transition: none !important;
}
.channel-comments .body .comments .comment[data-v-749b3a75] {
  display: flex;
  margin: 15px 10px 0px 0px;
}
.channel-comments .body .comments .comment .send-comment-icon[data-v-749b3a75] {
  padding: 0px 15px 0px 15px;
}
.channel-comments .body .comments .comment .send-comment-icon > *[data-v-749b3a75] {
  cursor: pointer;
}
.channel-comments .body .comments .comment .send-comment-block[data-v-749b3a75] {
  padding: 8px;
  background-color: var(--message-bg-color2);
  border-top-right-radius: 15px;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
}
.channel-comments .body .comments .comment .send-comment-block .send-comment-sec1[data-v-749b3a75] {
  display: flex;
  align-items: center;
}
.channel-comments .body .comments .comment .send-comment-block .send-comment-sec1 .send-comment-msg-name[data-v-749b3a75] {
  font-weight: bold;
  margin-bottom: 5px;
  white-space: nowrap;
  cursor: pointer;
}
.channel-comments .body .comments .comment .send-comment-block .send-comment-sec1 .send-comment-msg-time[data-v-749b3a75] {
  color: var(--message-time-color);
  font-size: 12px;
  text-align: right;
  width: 100%;
  margin-left: 10px;
}
.channel-comments .body .comments .comment .send-comment-block .send-comment-msg-text[data-v-749b3a75] {
  word-break: break-word;
  white-space: pre-wrap;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/channels/channelComments.vue"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,gCAAgC;EAChC,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,8CAA8C;EAC9C,mBAAmB;EACnB,iBAAiB;EACjB,wFAAwF;EACxF,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,mCAAmC;EACnC,UAAU;AACZ;AACA;EACE,cAAc;EACd,4CAA4C;EAC5C,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kDAAkD;AACpD;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,yCAAyC;EACzC,cAAc;AAChB;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;EACZ,0CAA0C;EAC1C,6BAA6B;EAC7B,+BAA+B;EAC/B,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,qBAAqB;AACvB","sourcesContent":[".fade-btn-enter-active[data-v-749b3a75] {\n  transition: all 0.6s;\n}\n.fade-btn-enter[data-v-749b3a75] {\n  opacity: 0;\n}\n.channel-comments[data-v-749b3a75] {\n  max-height: 90%;\n  width: 100%;\n  min-width: 300px;\n  margin: -25px -8px 15px -20px;\n}\n.channel-comments .header[data-v-749b3a75] {\n  padding-bottom: 0px;\n  padding-top: 10px;\n}\n.channel-comments .body[data-v-749b3a75] {\n  padding: 0px;\n  max-height: calc(var(--vh) * 85);\n  flex-direction: column;\n}\n.channel-comments .body .send-comment[data-v-749b3a75] {\n  display: flex;\n  margin-top: 15px;\n  border-radius: 5px;\n  width: 100%;\n}\n.channel-comments .body .send-comment .send-comment-icon[data-v-749b3a75] {\n  padding: 10px 5px 10px 15px;\n}\n.channel-comments .body .send-comment .send-comment-block[data-v-749b3a75] {\n  padding: 10px;\n  width: 100%;\n  position: relative;\n}\n.channel-comments .body .send-comment .send-comment-block .textarea[data-v-749b3a75] {\n  max-height: 300px;\n  overflow: auto;\n  width: 100%;\n  outline: none;\n  word-break: break-word;\n  color: var(--main-body-color);\n  border: 1px solid var(--list-item-bordercolor);\n  border-radius: 20px;\n  padding: 8px 16px;\n  transition: border-color 0.15s linear, background-color 0.15s linear, color 0.15s linear;\n  position: relative;\n  z-index: 10;\n  min-height: 40px;\n}\n.channel-comments .body .send-comment .send-comment-block .textarea[data-v-749b3a75]:hover {\n  border-color: var(--list-item-bordercolor);\n}\n.channel-comments .body .send-comment .send-comment-block .textarea[data-v-749b3a75]:focus {\n  border-color: var(--list-item-bordercolor);\n}\n.channel-comments .body .send-comment .send-comment-block .placeholder-textarea[data-v-749b3a75] {\n  position: absolute;\n  top: 19px;\n  left: 27px;\n  color: var(--custom-textarea-color);\n  z-index: 9;\n}\n.channel-comments .body .send-comment .send-comment-block .send-comment-btn[data-v-749b3a75] {\n  color: #8a92a4;\n  background-color: var(--comment-btn-bgcolor);\n  height: 40px;\n  border-radius: 20px;\n  text-align: center;\n  display: inline-block;\n  padding: 9px 30px;\n  margin-top: 12px;\n  cursor: pointer;\n}\n.channel-comments .body .send-comment .send-comment-block .send-comment-btn[data-v-749b3a75]:active {\n  background-color: var(--comment-btn-bgcolor-hover);\n}\n.channel-comments .body .send-comment .send-comment-block .send-comment-btn[data-v-749b3a75]:hover {\n  border-color: var(--list-item-bordercolor);\n}\n.channel-comments .body .send-comment .send-comment-block .active-btn[data-v-749b3a75] {\n  background-color: var(--modal-elem-color);\n  color: #ffffff;\n}\n.channel-comments .body .comments[data-v-749b3a75] {\n  overflow: auto;\n  width: 100%;\n}\n.channel-comments .body .comments .show-all[data-v-749b3a75] {\n  opacity: 1;\n  transition: all 0.7s;\n}\n.channel-comments .body .comments .hide-all[data-v-749b3a75] {\n  opacity: 0;\n}\n.channel-comments .body .comments .show-first[data-v-749b3a75]:first-child {\n  opacity: 1 !important;\n  transition: all 0.7s;\n}\n.channel-comments .body .comments .hide-first[data-v-749b3a75]:first-child {\n  opacity: 0 !important;\n  transition: none !important;\n}\n.channel-comments .body .comments .comment[data-v-749b3a75] {\n  display: flex;\n  margin: 15px 10px 0px 0px;\n}\n.channel-comments .body .comments .comment .send-comment-icon[data-v-749b3a75] {\n  padding: 0px 15px 0px 15px;\n}\n.channel-comments .body .comments .comment .send-comment-icon > *[data-v-749b3a75] {\n  cursor: pointer;\n}\n.channel-comments .body .comments .comment .send-comment-block[data-v-749b3a75] {\n  padding: 8px;\n  background-color: var(--message-bg-color2);\n  border-top-right-radius: 15px;\n  border-bottom-left-radius: 15px;\n  border-bottom-right-radius: 15px;\n}\n.channel-comments .body .comments .comment .send-comment-block .send-comment-sec1[data-v-749b3a75] {\n  display: flex;\n  align-items: center;\n}\n.channel-comments .body .comments .comment .send-comment-block .send-comment-sec1 .send-comment-msg-name[data-v-749b3a75] {\n  font-weight: bold;\n  margin-bottom: 5px;\n  white-space: nowrap;\n  cursor: pointer;\n}\n.channel-comments .body .comments .comment .send-comment-block .send-comment-sec1 .send-comment-msg-time[data-v-749b3a75] {\n  color: var(--message-time-color);\n  font-size: 12px;\n  text-align: right;\n  width: 100%;\n  margin-left: 10px;\n}\n.channel-comments .body .comments .comment .send-comment-block .send-comment-msg-text[data-v-749b3a75] {\n  word-break: break-word;\n  white-space: pre-wrap;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
